import React, { useEffect, useState } from "react";
import Header from "./../components/Header";
import Message from "../components/LoadingError/Error";
import { useDispatch, useSelector } from "react-redux";
import { listProductDetails } from "../Redux/Actions/ProductActions";
import Loading from "../components/LoadingError/Loading";
import BreadcrumbNav from "../components/homeComponents/BreadcrumbNav";

const SingleProduct = ({ history, match }) => {
  const [qty, setQty] = useState(1);
  const [mainImageIndex, setMainImageIndex] = useState(0);
  const [selectedSize, setSelectedSize] = useState("");
  const [selectedColor, setSelectedColor] = useState("");

  const productId = match.params.id;
  const dispatch = useDispatch();

  const productDetails = useSelector((state) => state.productDetails);
  const { loading, error, product } = productDetails;

  const formatCOP = (value) =>
    new Intl.NumberFormat("es-CO", {
      style: "decimal",
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    }).format(Number(value));

  useEffect(() => {
    dispatch(listProductDetails(productId));
    setMainImageIndex(0);
  }, [dispatch, productId]);

  useEffect(() => {
    if (
      product?.hasSizes &&
      Array.isArray(product?.sizes) &&
      product.sizes.length
    ) {
      setSelectedSize(product.sizes[0]);
    } else {
      setSelectedSize("");
    }

    if (
      product?.hasColors &&
      Array.isArray(product?.colors) &&
      product.colors.length
    ) {
      setSelectedColor(product.colors[0]);
    } else {
      setSelectedColor("");
    }
  }, [product]);

  const AddToCartHandle = (e) => {
    e.preventDefault();

    if (product?.hasSizes && !selectedSize) {
      alert("Debes seleccionar una talla");
      return;
    }

    if (product?.hasColors && !selectedColor) {
      alert("Debes seleccionar un color");
      return;
    }

    history.push(
      `/cart/${productId}?qty=${qty}&size=${encodeURIComponent(
        selectedSize
      )}&color=${encodeURIComponent(selectedColor)}`
    );
  };

  const images =
    Array.isArray(product?.images) &&
    product.images.length
      ? product.images
          .map((item) => {
            if (typeof item === "string") {
              return item;
            }

            return item?.url || "";
          })
          .filter(Boolean)
      : product?.image
        ? [product.image]
        : [];

  return (
    <>
      <Header />
      <BreadcrumbNav
        items={[
          product?.category && {
            label: product.category.name,
            to: `/categorias/${product.category.slug}`,
          },
          product?.department && {
            label: product.department.name,
            to: `/categorias/${product.category.slug}/departamento/${product.department.slug}`,
          },
          product?.name && {
            label: product.name,
          },
        ]}
      />
      <div className="container single-product">
        {loading ? (
          <Loading />
        ) : error ? (
          <Message variant="alert-danger">{error}</Message>
        ) : (
          <div className="row">
            <div className="col-md-6">
              <div className="sp-gallery-v2">
                {images.length > 1 && (
                  <div className="sp-thumbs-v2">
                    {images.map((img, idx) => (
                      <button
                        key={idx}
                        type="button"
                        className={`sp-thumb-v2 ${
                          idx === mainImageIndex ? "active" : ""
                        }`}
                        onClick={() => setMainImageIndex(idx)}
                      >
                        <img src={img} alt={`${product.name} ${idx + 1}`} />
                      </button>
                    ))}
                  </div>
                )}

                <div className="sp-main-wrap-v2">
                  <div className="sp-main-v2">
                    {images.length > 0 && (
                      <img
                        src={images[mainImageIndex]}
                        alt={product.name || "Producto"}
                      />
                    )}
                  </div>
                </div>
              </div>
            </div>

            <div className="col-md-6">
              <div className="product-dtl">
                <div className="product-info">
                  <div className="product-name">{product.name}</div>
                </div>

                <div className="product-description">
                  <p>{product.description}</p>
                </div>

                <div className="product-count col-lg-7">
                  <div className="flex-box d-flex justify-content-between align-items-center">
                    <h6>Precio</h6>

                    {Number(product.discount || 0) > 0 ? (
                      <div className="single-price-row">
                        <span className="single-price-discounted">
                          ${formatCOP(product.discountedPrice)}
                        </span>

                        <span className="single-price-original">
                          ${formatCOP(product.price)}
                        </span>
                      </div>
                    ) : (
                      <span>${formatCOP(product.price)}</span>
                    )}
                  </div>

                  <div className="product-options">
                    {product?.hasSizes && !!product?.sizes?.length && (
                      <div className="option-block">
                        <h6 className="option-title">Talla</h6>

                        <div className="option-grid">
                          {product.sizes.map((size) => (
                            <button
                              key={size}
                              type="button"
                              className={`option-item ${
                                selectedSize === size ? "active" : ""
                              }`}
                              onClick={() => setSelectedSize(size)}
                            >
                              {size}
                            </button>
                          ))}
                        </div>
                      </div>
                    )}

                    {product?.hasColors && !!product?.colors?.length && (
                      <div className="option-block">
                        <h6 className="option-title">Color</h6>

                        <div className="option-grid">
                          {product.colors.map((color) => (
                            <button
                              key={color}
                              type="button"
                              className={`option-item ${
                                selectedColor === color ? "active" : ""
                              }`}
                              onClick={() => setSelectedColor(color)}
                            >
                              {color}
                            </button>
                          ))}
                        </div>
                      </div>
                    )}
                  </div>

                  {product.status === "active" ? (
                    <>
                      <div className="quantity-row">
                        <h6>Cantidad</h6>

                        <div className="quantity-control">
                          <button
                            type="button"
                            className="quantity-btn"
                            onClick={() =>
                              setQty((prev) => Math.max(1, prev - 1))
                            }
                            disabled={qty <= 1}
                          >
                            −
                          </button>

                          <span className="quantity-value">{qty}</span>

                          <button
                            type="button"
                            className="quantity-btn"
                            onClick={() => setQty((prev) => prev + 1)}
                          >
                            +
                          </button>
                        </div>
                      </div>

                      <button
                        onClick={AddToCartHandle}
                        className="round-black-btn"
                      >
                        Añadir al carrito
                      </button>
                    </>
                  ) : null}
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default SingleProduct;